
import { Vue } from "vue-class-component";

export default class GreyPlus extends Vue {}
